export function fadeOut (element, removeFromDom = false) {
  let opacity = 1

  function decreaseOpacity () {
    opacity -= 0.05

    if (opacity <= 0) {
      element.style.opacity = 0

      if (removeFromDom) {
        element.remove()
      }

      return
    }

    element.style.opacity = opacity
    window.requestAnimationFrame(decreaseOpacity)
  }

  decreaseOpacity()
}
